import { render, staticRenderFns } from "./dui-book-cover.vue?vue&type=template&id=24709fbb&scoped=true&"
import script from "./dui-book-cover.vue?vue&type=script&lang=js&"
export * from "./dui-book-cover.vue?vue&type=script&lang=js&"
import style0 from "./dui-book-cover.vue?vue&type=style&index=0&id=24709fbb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24709fbb",
  null
  
)

export default component.exports